import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../services";
import { ArrowBack } from "@mui/icons-material";
import { MotorBodyTypeForm } from "./components/motorBodyTypeForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditMotorBodyType = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [bodyTypeData, setBodyTypeData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/body-type/${paramId}`).then(
            (res) => {
              setBodyTypeData((prevData) => ({
                ...prevData,
                ...res?.data,
              }));
            }
          );
        } catch (error) {
          console.error("Error Fetching",error);
          showSnackbar(error?.response?.data?.message || "Network Error","error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  const handleUpdateBodyType = async (bodyTypeData) => {
    try {
          const bodyTypeUpdateData = {
            name: bodyTypeData.name,
            isActive: bodyTypeData.active,
          };
          const response = await putData(
            `/reference/motor/body-type/${bodyTypeData.id}`,
            bodyTypeUpdateData
          );

          if (response?.success) {
            showSnackbar(response?.message,"success");
            navigate("/motor-master/motor-bodyType");
          }
        } catch (error) {
          console.error("Error Updating",error);
          showSnackbar(error?.response?.data?.message, "error");
        }
  };

  const handleBack = async () => {
    navigate("/motor-master/motor-bodyType", {
      state: {
        currentPage: location?.state?.currentPage,
        rowsPerPage: location?.state?.rowsPerPage,
      },
    });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => handleBack()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Body Type details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Body Type details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorBodyTypeForm
            onsubmit={handleUpdateBodyType}
            editBodyTypeData={bodyTypeData}
          />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorBodyType;
